// components/GamesNavbar.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import DonationButton from "../../components/DonationButton";
import Navbar from "../../components/Navbar";

export default function GamesNavbar({
  settingsBtnIconClassName = "",
  shareBtnIconClassName = "",
  showActionBtn = false,
  handleSettingsBtnOnClick,
  handleShareBtnOnClick,
  rightSlot,
}) {
  const { t } = useTranslation();

  return (
    <Navbar
      className="as-navbar--games"
      brandSubtitle={`🎮 ${t("games.landing.title_suffix")}`}
      brandSubtitleClassName="as-navbar-subtitle--hide-xs"
      settingsBtnIconClassName={settingsBtnIconClassName}
      shareBtnIconClassName={shareBtnIconClassName}
      showActionBtn={showActionBtn}
      handleSettingsBtnOnClick={handleSettingsBtnOnClick}
      handleShareBtnOnClick={handleShareBtnOnClick}
      rightSlot={
        <>
          <DonationButton className="btn btn-sm as-btn-soft" />
          {rightSlot ? rightSlot : null}
        </>
      }
    />
  );
}
